if(!customElements.get('related-articles')) {
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();
      this.blogUrl = this.dataset.blogUrl;
      this.articleTags = JSON.parse(this.dataset.articleTags);
      this.articleTags = this.articleTags.map(function(tag) {return $s.handleize(tag);});
      if (this.dataset.tagsAllowed) {
        this.tagsAllowed = JSON.parse(this.dataset.tagsAllowed);
        if (this.tagsAllowed.length > 0) {
          //array intersection
          let tags = this.tagsAllowed.map(function(tag) {return $s.handleize(tag);});
          this.articleTags = this.articleTags.filter(function(n) {return tags.indexOf(n) !== -1;});        
        }
      }
      this.articleId = this.dataset.articleId;
      this.itemsLimit = parseInt(this.dataset.itemsLimit);
      this.loadItems();
    }

    loadItems() {
      var articleId = this.articleId;
      var self = this;
      var url = this.blogUrl;
      var articlesIds = [];
      var articles = [];
      var waiting = 0;
      var itemsLimit = this.itemsLimit;
      var articleTags = this.articleTags;
      var tagsQueries = [];
      var parser = new DOMParser();
      for (var i=0; i<articleTags.length; i++) {
        tagsQueries.push(articleTags.slice(0, articleTags.length - i));
      }
      if (tagsQueries.length>3) {
        tagsQueries.splice(2, tagsQueries.length-3);
      }
      for (var i=0; i<tagsQueries.length; i++) {
        var tags = tagsQueries[i].join('+');
        waiting++;
        $s.get({
          url: url + '/tagged/'+tags+'?view=related_articles',
          cache: false,
          success: function(data){
            var items = data.split('<!-- article separator -->');
            items.forEach(function(item) {
              var doc = parser.parseFromString(item, 'text/html');
              var element = doc.querySelector('.article-item');
              articles.push(element);
            })
          },
          always: function() {
            waiting--;
            if(waiting == 0){
              
              articles.sort(function(obj1, obj2) {
                var obj1TagsFilter = obj1.dataset.tagsfilter.split(',');
                var obj2TagsFilter = obj2.dataset.tagsfilter.split(',');
                if (obj1TagsFilter.length==obj2TagsFilter.length)
                  return obj2.dataset.publishedDate > obj1.dataset.publishedDate ? 1 : -1;
                else
                  return obj2TagsFilter.length > obj1TagsFilter.length ? 1 : -1;
              });
              var idsShown = {};
              var shown = 0;
              articles.forEach(function(item,i ) {
                if(shown < itemsLimit && item.dataset.articleId != articleId){
                  if (!(idsShown[item.dataset.articleId])) {
                    self.querySelector(".articles-wrapper").insertAdjacentElement('beforeend', item);
                    idsShown[item.dataset.articleId] = item;
                    shown++;
                  }
                }
              });
              if (shown>0) {
                self.classList.remove('hide');

                // keen slide this if needed => self.querySelector(".articles-wrapper");

                var layoutTId = 0;
                var lastWidth = null;
                function layout() {
                  if (lastWidth != window.innerWidth) {
                    lastWidth = window.innerWidth;
                    clearTimeout(layoutTId);
                    layoutTId = setTimeout(function() {
                      if (window.innerWidth>600) {
                        $s.matchHeight(self.querySelectorAll(".articles-wrapper .title"));
                      } else {
                        self.querySelectorAll(".articles-wrapper .title").forEach(function(item){
                          item.style.minHeight = '';
                        });
                      }
                    }, 300);
                  }
                }
                window.addEventListener('resize', layout);
                layout();
                
              }
            }
          }
        }) //end $s.get
      } //end for loop
    }

  }
  customElements.define('related-articles', RelatedArticles);
}